export const VIEW_TYPE_KEY = 'view-type-products';
